<p-confirmDialog #cd key="{{ key }}" header="{{ header | hisUi }}">
    <p-footer>
        <button (click)="cd.accept()" type="button">
            <span>{{ 'de.his.javang.ok' | hisUi}}</span>
        </button>
    </p-footer>
</p-confirmDialog>
